import { getLink, getPhoneNumber } from '@helpers/env'
import styles from './styles.module.scss'
import Link from '@components/ui/Link'
import { ReactComponent as InstagramIcon } from '@svgs/social/instagram.svg'
import { ReactComponent as FacebookIcon } from '@svgs/social/facebook.svg'
import { ReactNode } from 'react'

const phoneNumber = getPhoneNumber()

type SocialIconProps = {
  url: string
  children: ReactNode
}
function SocialIcon({ url, children }: SocialIconProps) {
  return (
    <a href={getLink(url)} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export default function ContactInfo() {
  return (
    <div className={styles.FooterContactInfo}>
      <h5 className={styles.FooterContactInfo__title}>Get in touch</h5>

      <dl className={styles.FooterContactInfo__items}>
        <dd>
          <Link
            href={`tel:${phoneNumber}`}
            underlined={false}
            text={phoneNumber}
          />
        </dd>
        <dd>
          <Link
            href="mailto:hello@spoke-london.com"
            underlined={false}
            text="hello@spoke-london.com"
          />
        </dd>
        <dd>
          <Link
            href="mailto:press@spoke-london.com"
            underlined={false}
            text="press@spoke-london.com"
          />
        </dd>
      </dl>

      <div className={styles.FooterContactInfo__social}>
        <SocialIcon url="https://www.instagram.com/spoke_london/">
          <InstagramIcon />
        </SocialIcon>
        <SocialIcon url="https://www.facebook.com/spokefit">
          <FacebookIcon />
        </SocialIcon>
      </div>
    </div>
  )
}
